import * as types from "./types";
import { HttpClient, MHTTPCL } from "../../../../services/http/http-client";
import { ProjectsService } from "../../services/projects.service";
import { getNavTabModule } from "../../../../dt-plugins/sidewindow/nav-tab";
import { setMainNavInactive } from "../../../../store/app/mutations";
import router from "../../../../router";

// Action Object for ProjectsCatalog. Import the types from projects/types.js and Invoke Actions from the Vuex Host Components.

const NavTabModule = getNavTabModule(types.ProjectDetails, "projectDetails");

export const projectsCatalogActions = {
  async [types.ProjectsCatalogData.FETCH.ALL](
    { commit, getters, dispatch },
    payload
  ) {
    const projectsCatalogData = await HttpClient.mergeRequests([]);
    console.log(projectsCatalogData);
    commit(types.ProjectsCatalogData.SET.ALL, projectsCatalogData);
  },

  // Project List & Search
  async [types.ProjectList.FETCH.ALL]({ commit, getters }, payload) {
    // console.log("search payload ", payload);
    const { searchString, startFrom, row_count } = payload;

    if (searchString && searchString.length > 0) {
      const res = await ProjectsService.searchProjectList(searchString);
      // console.log("Search res ", res.data);
      commit(types.ProjectList.SET.ALL, res.data);
    } else {
      const res = await ProjectsService.getProjects();
      // console.log("Projects res ", res.data);
      commit(types.ProjectList.SET.ALL, res.data);
    }
  },
  // Deleted Project List
  async [types.ProjectList.DELETE.SINGLE]({ commit, getters }, item) {
    const { project_id } = item;

    let newProjectList = getters.projectList.all_l_projects.filter(
      e => e.project_id != project_id
    );

    commit(types.ProjectList.SET.ALL, {
      ...getters.projectList,
      all_l_projects: newProjectList
    });

    const removeProject = await ProjectsService.removeProject(project_id);
  },

  // Show Sidewindow
  async [types.ProjectDetails.FETCH.SINGLE](
    { commit, getters, dispatch },
    payload = {}
  ) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    let { flag, project, reload } = payload;
    console.log("paylod ", payload);

    flag = typeof flag === "boolean" ? flag : true;

    setMainNavInactive(commit, flag);

    const primaryKey = "project_id";
    const itemName = "project";
    const item = payload[itemName];

    if (!item) {
      return;
    }

    const primaryKeyValue = item[primaryKey];
    const detailsGetterKey = "projectDetails";
    const DetailsAction = types.ProjectDetails;

    // Check Reload and prexisting Item Logic
    if (getters?.[detailsGetterKey]?.[primaryKeyValue] && !reload) {
      return;
    }

    NavTabHelper.setSingleNavTabDetails(primaryKeyValue, () => {
      return {
        [itemName]: item,
        loading: true
      };
    });

    // HTTP Req
    const detailsData = await HttpClient.mergeRequests([
      ProjectsService.fetchProjectDetails(project.project_id),
      ProjectsService.fetchProjectOverviewSetupTab(project.project_id),
      ProjectsService.fetchRelatedContacts(project.project_id),
      ProjectsService.fetchSalesPlanningPhyTab(project.project_id),
      ProjectsService.fetchSalesPlanningDigitalTab(project.project_id),
      ProjectsService.fetchBudgetTab(project.project_id),
      ProjectsService.costTab(project.project_id),
      ProjectsService.costTab(project.project_id),
      ProjectsService.searchCosts({
        project_id: project.project_id,
        start: 0,
        cost_group_id: "",
        marketing_type_id: "",
        date_start: "",
        date_end: ""
      }),
     // ProjectsService.calculationTab(project.project_id)
    ]);

    console.log("detailsData", detailsData);

    // DBox
    NavTabHelper.setSingleNavTabDetails(
      primaryKeyValue,
      (detailsDict, project) => {
        return {
          ...project,
          ...detailsData,
          loading: false
        };
      }
    );
  },

  // Left NavItem child details
  ...NavTabModule.implementActions(
    "project_id",
    "projects/project_id/tab",
    "projects",
    () => router,
    "catalog",
    (value, key) => {
      return {
        title:
          value && value.project && value.project.project_name
            ? value.project.project_name
            : key,
        full_title:
          value && value.project && value.project.project_name
            ? value.project.project_name
            : key
      };
    }
  ),

  // Notes - Action of Updating single Object
  async [types.ProjectDetails.UPDATE.SINGLE]({ dispatch, getters }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { name, value, selectedProjectDetails } = payload;
    const { project } = selectedProjectDetails;
    const { project_id } = project;

    NavTabHelper.updateSingleNavTabDetails(project_id, projectObj => {
      return {
        project: {
          ...projectObj.project,
          [name]: value
        }
      };
    });

    const table = "l_projects";

    const updatedProjectDetailsRes = await MHTTPCL.modify(
      "project_id",
      project_id,
      name,
      value,
      table
    );
    // const updatedProjectDetailsRes = await MHTTPCL.post(
    //   MODIFICATION_URL,
    //   {
    //     key: "project_id",
    //     kVal: project_id,
    //     name,
    //     value,
    //     table,
    //     modified: "2021-06-07+08:21:03",
    //     DOMid: "label_1588_isrc_base"
    //   }
    // );
  },

  // Start Related Contacts
  async [types.ProjectRelatedContacts.UPDATE.SINGLE](
    { commit, getters, dispatch },
    payload
  ) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { name, value, item, selectedProjectDetails } = payload;
    const { project_id } = selectedProjectDetails;

    const key = "contact_relation_id";
    const kVal = item[key];
    const table = "contact_relations";

    NavTabHelper.updateSingleNavTabDetails(project_id, projectDetailsObj => {
      return {
        contact_relations: projectDetailsObj.contact_relations.map(e => {
          if (e.contact_relation_id == item.contact_relation_id) {
            return {
              ...e,
              [name]: value
            };
          } else {
            return e;
          }
        })
      };
    });

    const modifiedProject = await MHTTPCL.modifyJSON(
      undefined,
      kVal,
      name,
      value,
      table
    );
  },

  async [types.ProjectRelatedContacts.DELETE.SINGLE](
    { commit, getters, dispatch },
    payload
  ) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    // console.log("contact payload", payload);

    const { contact, selectedProjectDetails } = payload;
    const { project_id } = selectedProjectDetails;
    const { contact_relation_id } = contact;

    NavTabHelper.updateSingleNavTabDetails(project_id, projectDetailsObj => {
      return {
        contact_relations: projectDetailsObj.contact_relations.filter(
          e => e.contact_relation_id != contact_relation_id
        )
      };
    });

    const deletedContact = await ProjectsService.deleteContactRelation(
      contact_relation_id
    );
  },

  async [types.ProjectRelatedContacts.SET.ALL](
    { commit, getters, dispatch },
    { contact_relations, external_table, external_id }
  ) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    NavTabHelper.updateSingleNavTabDetails(
      external_id,
      (_, projectDetailsObject) => {
        return {
          ...projectDetailsObject,
          contact_relations: contact_relations
        };
      }
    );
  },
  // End Related Contacts

  // Start Related Contacts
  async [types.ProjectCosts.UPDATE.SINGLE](
    { commit, getters, dispatch },
    payload
  ) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { name, value, item, selectedProjectDetails } = payload;
    const { project_id } = selectedProjectDetails;
    // console.log("Costs payload", payload);

    const key = "cost_split_id";
    const kVal = item[key];
    const table = "cost_splits";

    NavTabHelper.updateSingleNavTabDetails(project_id, projectDetailsObj => {
      return {
        costs: projectDetailsObj.costs.map(e => {
          if (e.cost_split_id == kVal) {
            return {
              ...e,
              [name]: value
            };
          } else {
            return e;
          }
        })
      };
    });

    const modifiedCosts = await MHTTPCL.modifyJSON(
      undefined,
      kVal,
      name,
      value,
      table
    );
  },
  async [types.ProjectCostsLine.FETCH.ALL](
    { commit, getters, dispatch },
    payload
  ) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    console.log("PAYLOAD::::", payload);
    const { file_id } = payload;

    const costs = await ProjectsService.getProjectLinesByFileId(file_id);

    console.log("NEW ORDERLINE", costs.data.costs);

    // NavTabHelper.updateSingleNavTabDetails(project_id, oldOrder => {
    //   return {
    //     costs: [...costs.data.costs]
    //   };
    // });
  }
};

// kVal	"5318"
// name	"marketing_type_id"
// value	"2"
// table	"cost_splits"
// modified	"2022-03-22+11:52:10"
// DOMid	"marketing_type_id_5318"
// modify_type	""
// json_op	""
// json_key	""
